import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { Equipo } from '@domain/equipo';
import { RetoTcPage } from '@pages';
import { Jugador } from '@domain/jugador';
import { EstatusRetosEquipo } from '@domain/estatus.reto.equipo';

@IonicPage()
@Component({
  selector: 'page-cargador-tc',
  templateUrl: 'cargador-tc.html',
})
export class CargadorTcPage {

  equipo: Equipo;
  jugador: Jugador;
  estatus: EstatusRetosEquipo;
  preguntas: Array<any>;
  count: number = 3;
  interval: any;

  readonly AUDIO_FIN = 'assets/audios/countdown.wav';
  private  audio = new Audio();

  constructor(public navCtrl: NavController, public navParams: NavParams) {
    this.equipo = this.navParams.get('equipo');
    this.jugador = this.navParams.get('jugador');
    this.preguntas = this.navParams.get('preguntas');
    this.estatus = this.navParams.get('estatus');
  }

  ionViewDidLoad() {
    this.iniciaContador();
    this.audio.src = this.AUDIO_FIN;
    this.audio.load();
    this.audio.play();
  }

  iniciaContador() {
    this.interval = setInterval(() => {
      this.count--;
      if(this.count === 0) {
        this.cancelaInterval();
        this.navCtrl.setRoot(RetoTcPage, {
          preguntas: this.preguntas,
          equipo: this.equipo,
          jugador: this.jugador
        });
      }
    }, 1200);
  }

  cancelaInterval() {
    clearInterval(this.interval);
  }

}



// WEBPACK FOOTER //
// ./src/pages/team-challenge/cargador-tc/cargador-tc.ts